import {Modal as GWCModal, SidePanelProps as GWCSidePanelProps} from '@gwc/core'

export type SidePanelProps = Omit<GWCSidePanelProps<'div'>, 'direction'> & {
  /** Если true, панель не блокирует взаимодействие с пользователем за своими пределами.
   * @default false
   */
  persistent?: boolean
  anchor: GWCSidePanelProps<'div'>['direction']
}

export function SidePanel({persistent, disableAutoFocus = true, anchor, ...props}: SidePanelProps) {
  const persistentProps: Partial<GWCSidePanelProps<'div'>> = {
    preventScroll: false,
    backdrop: {
      style: {
        pointerEvents: 'none',
      },
      visible: false,
    },
  }

  const finalProps = !!persistent ? {...props, ...persistentProps} : props

  return (
    <GWCModal.SidePanel
    overlay={{zIndex: 950}}
    direction={anchor}
    disableAutoFocus={disableAutoFocus}
    {...finalProps}
    />
  )
}
